<template>
  <div>       
    <v-container  grid-list-xl> 
        <v-layout align-center="" justify-center="">
            <v-col sm="12" cols="12">
                <v-card>
                    <not-cpanel-tab 
                        :not_show="true"
                        :not="not" /> 
                    <v-card-title class="primary white--text">
                        <div v-if="!news">
                            <div class="not-f7 font-italic">No news found</div> 
                        </div>
                        <div v-else>
                            <div class="not-f7 font-italic">{{newsSize}} news found</div> 
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=!dialog" color="white" outlined="" rounded="" small="">add <v-icon>add_circle</v-icon></v-btn>
                    </v-card-title> 
                    <v-layout v-if="!page_show">
                        <not-page-spinner :not_show="true" /> 
                    </v-layout> 
                    <div v-else>
                        <v-card-text class="primary lighten-5 pa-5">
                            <v-row>
                                <v-col sm="12"  >
                                    <v-list>
                                        <v-sheet v-if="newsSize===0">
                                            <v-layout align-center="" justify-center="" class="pa-10">
                                                <v-icon>warning</v-icon> <div class="ml-2 mt-1 font-weight-bold">No news found</div>
                                            </v-layout>
                                        </v-sheet>
                                        <v-sheet v-else v-for="(study, index) in p_news.list" :key="index">
                                            <v-list-item >
                                                <v-list-item-action>
                                                    <div v-if="!study.image">
                                                        <v-img
                                                            :src="not.noImg"
                                                            :lazy-src="not.imgLazy"
                                                            height="50"
                                                            max-width="80"
                                                            class="grey lighten-2"/> 
                                                    </div>
                                                    <div v-else>
                                                        <v-img
                                                            :src="study.image.link"
                                                            :lazy-src="not.imgLazy"
                                                            height="50"
                                                            max-width="80"
                                                            class="grey lighten-2"> 
                                                            <v-layout
                                                                slot="placeholder"
                                                                fill-height
                                                                align-center
                                                                justify-center
                                                                ma-0
                                                                >
                                                                <v-progress-circular indeterminate color="grey lighten-5"/> 
                                                            </v-layout>
                                                        </v-img>    
                                                    </div> 
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{study.title}}</v-list-item-title> 
                                                    <v-list-item-subtitle>{{study.reported_by}}</v-list-item-subtitle>
                                                    <v-list-item-subtitle>{{not.convertDate(study.reported_date)}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-layout row wrap>
                                                        <v-btn  @click="editNews(study)" icon=""><v-icon>edit</v-icon></v-btn>
                                                        <v-btn  @click="not.go('/news/'+study.key)" icon=""><v-icon>mdi-eye</v-icon></v-btn>
                                                        <v-btn @click="deleteNews(study)" icon=""><v-icon>delete</v-icon></v-btn>
                                                        
                                                    </v-layout>
                                                </v-list-item-action>
                                            </v-list-item> 
                                            <v-divider></v-divider>
                                        </v-sheet>
                                    </v-list>
                                </v-col>
                            </v-row>
                            <br>
                            <v-divider></v-divider>
                            <div class="px-5">
                                <v-pagination
                                    v-model="page_current"
                                    class="mt-4"
                                    :length="p_news?p_news.pages:0"/> 
                            </div>
                                
                        </v-card-text> 
                    </div>
                </v-card>
            </v-col>  
        </v-layout>
        <br>
    </v-container> 
    
    <!-- dialog new item -->
    <v-dialog v-model="dialog" persistent max-width="600px"> 
      <v-card color="b1">
        <v-card-title class="primary white--text" dark>
          <span class="headline">ADD A NEWS</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <form id="itemDetailForm" @submit.prevent="submited()">
                <v-layout row wrap class="pa-1">   
                    <!-- Title -->
                    <v-flex xs12   > 
                        <v-text-field required  
                        v-model="input.title" 
                        label="Title"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field required 
                        v-model="input.reported_by" 
                        label="Reported By" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field required 
                        v-model="input.reported_date" 
                        label="Reported Date" > 
                        </v-text-field >
                    </v-flex> 
                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="input.desc" 
                            required  filled=""
                            label="description" >
                            </v-textarea>
                    </v-flex> 
                <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text="" @click="addNews()">CANCEL</v-btn>
                <v-btn color="blue darken-1" :loading="input.loading" dark="" type="submit">ADD</v-btn>
                </v-card-actions>
            </form> 
          </v-container> 
        </v-card-text>
        
      </v-card>
    </v-dialog>
    <!-- dialog Edit item -->
    <v-dialog v-model="dialog_edit" persistent max-width="600px"> 
      <v-card color="b1">
        <v-card-title class="primary white--text" dark>
          <span class="headline">ADD A NEWS</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <form id="itemDetailForm" @submit.prevent="submitedEdit()">
                <v-layout row wrap class="pa-1">   
                    <!-- Title -->
                    <v-flex xs12   > 
                        <v-text-field required  
                        v-model="input.title" 
                        label="Title"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field required 
                        v-model="input.reported_by" 
                        label="Reported By" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field required 
                        v-model="input.reported_date" 
                        label="Reported Date" > 
                        </v-text-field >
                    </v-flex> 
                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="input.desc" 
                            required  filled=""
                            label="description" >
                            </v-textarea>
                    </v-flex>  
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text="" @click="dialog_edit=false">CANCEL</v-btn>
                <v-btn color="blue darken-1" :loading="input.loading" dark="" type="submit">Edit</v-btn>
                </v-card-actions>
            </form> 
          </v-container> 
        </v-card-text>
        
      </v-card>
    </v-dialog>
  </div> 
</template>

<script>
    let pageName = "News"
    let ACTION_TIME = 100
    export default {
        name:pageName,
        props:["not"],
        data() {
        return {
            page_show:false, 
            page_current:1,
            page_size:10,

            dialog:false,
            dialog_edit:false,
            tab: null, 
            input:{},
            images:[
                {src:require(`@/assets/awrim/group/g6.jpeg`),local:true},  
            ]
        }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notText:false,
                notIndicators:true,
                notHeight:"350",
                notImages:this.images
            })
           this.pageLoad(1000)
        },
        computed: {
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            
            news(){
                return this.$store.getters.getNews
            },
            newsSize(){
                let bs = this.news
               return bs?bs.length:0
            },
            p_news(){
                if (!this.news) {
                    return null
                }
                let list = [...this.news]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            }
        },
        methods: {
            
            clicked(){},
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+"=ADD-NEWS") {
                        if (this.input.check ) {
                            this.input.check = false 
                                setTimeout(() => {
                                this.$store.dispatch("fi_add",{
                                    action:"News",
                                    path:"TERESIAN/SETTINGS/News/",
                                    data:this.input
                                }) 
                            }, ACTION_TIME);  
                        } 
                    }
                    if (action.code ===pageName+'=EDIT-NEWS') {
                        if (this.input.check) {   
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_update",{
                                    action:"News",
                                    path:"TERESIAN/SETTINGS/News/"+action.data.key+"/",
                                    data:action.data,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);  
                        } 
                    } 
                    else if (action.code===pageName+':'+2) {
                        this.input = {}
                        this.dialog = false
                    }else if (action.code===pageName+':'+3) {
                        this.$store.dispatch("fi_add",{
                            action:"News",
                            path:"TERESIAN/SETTINGS/News/",
                            data:this.input
                        })
                    }else if (action.code===pageName+"=DELETE-NEWS") { 
                        this.$store.dispatch("fi_delete",{
                            action:"News",
                            path:"TERESIAN/SETTINGS/News/"+action.key
                        })
                    }else if (action.code===pageName+':'+5) { 
                        this.$store.dispatch("fi_deleteImage",{
                            path:"TERESIAN/SETTINGS/News/"+action.key,
                            link:action.image.link,
                            action:"News"
                        }) 
                    }
                }
            },
            addNews(){
                this.input = {}
                this.dialog = !this.dialog
            },
            
            submited(){
                let total = this.not.TOTAL_C.news
                let size = this.newsSize
                if (total<=size) {
                    this.not.notDialog(true,true,"Disk Full","You have reached total number of news that can be added on the system.","","OK")
                } else {
                    this.input.check = true
                    this.not.notDialog(true,true,"ADD","You are about to add new news.","Cancel","Add",{
                        code:pageName+"=ADD-NEWS",
                        data:this.input
                    }) 
                }
            },
            editNews(news){
                this.input = {}, 
                this.input.key = news.key
                this.input.title = news.title
                this.input.reported_by = news.reported_by
                this.input.reported_date = news.reported_date
                this.input.desc = news.desc
                this.input.link = news.link?news.link:null
                this.dialog_edit = true
            },
            submitedEdit(){ 
                this.input.check = true
                this.not.notDialog(true,true,"EDIT NEWS",'Are you sure you want to edit this news','CANCEL',"EDIT",{
                    code:pageName+"=EDIT-NEWS",
                    data:this.input
                })
                 
            },
            deleteNews(item){
               let image = item.image
                let key = item.key
                if (image) {
                    this.not.notDialog(true,true,"DELETE IMAGE FIRST","You must delete image before deleting this news.","Cancel","Delete Image",{code:pageName+':'+5,key:key,image:image}) 
                }else{
                    this.not.notDialog(true,true,"DELETE","You are about to delete this news.","Cancel","Delete",{
                        code:pageName+"=DELETE-NEWS",
                        key:key
                    }) 
                }
            },

            //LOAD
            show(){
                if (!this.us) {
                    this.not.go("/")
                }
            },
             pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses

                    //Check proccess 
                    if (ps) {
                        let getting = ps.find(process=>{
                            return process.name == 'getting/News'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/News'
                        })
                        let updating = ps.find(process=>{
                            return process.name == 'updating/News'
                        }) 
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/News'
                        })
                        let deletingImage = ps.find(process=>{
                            return process.name == 'deleting/image/News'
                        })

                        if (getting) {
                            this.page_show =false
                        }else{
                            this.page_show =true
                        }

                        if (adding) {
                            this.not.notDialogP(true,true,'adding...')
                            this.input.loading = true
                        }else{ 
                        }  

                        if (updating) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        } 
    
    
                        if (deleting) {
                            this.not.notDialogP(true,true,'deleting...') 
                        }else{ 
                        }  

                        if (deletingImage) {
                            this.not.notDialogP(true,true,'deleting image...') 
                        }else{ 
                        }  
                    }else{
                        this.page_show =true
                    }

                    //check response
                    if (res.res==='adding/News/successful') { 
                        this.not.notDialog(true,true,'Successful','News, successfully added.','','OK',{
                            code:pageName+':'+2
                            })
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='adding/News/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding News.','Cancel','Try again',{code:pageName+':'+3})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/News/successful') { 
                        this.not.notDialog(true,true,'Successful','News, successfully deleted.','','OK')
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/News/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting News.','OK')
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/image/News/successful') { 
                        this.not.notDialog(true,true,'Successful','Image, successfully deleted.','','OK')
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/image/News/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting sermon.','OK') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }


                    if (res.res==='updating/News/successful') { 
                        this.not.notDialog(true,true,'Successful','News successfully edited.','','OK',{code:pageName+'=EDIT-NEWS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_edit = false
                    }else if (res.res==='updating/News/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the News. make sure your password is correct or contact admin','','OK',{code:pageName+'=EDIT-NEWS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
        },
        watch: {
            us(v){
                this.show()
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 